import {
  APPLICATION_FILLOUT_DATA_REQUEST,
  APPLICATION_FILLOUT_DATA_SUCCESS,
  APPLICATION_FILLOUT_DATA_FAIL,
} from '../constants/applicationFilloutConstants';

export const applicationFilloutReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case APPLICATION_FILLOUT_DATA_REQUEST:
      return { loading: true, formData: [] };
    case APPLICATION_FILLOUT_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case APPLICATION_FILLOUT_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
